import axios from 'axios';
import util from 'util/baseUtil';

const chat = function() {
  
  const CancelToken = axios.CancelToken;
  let source = CancelToken.source();


  /**
   * ajax 요청 취소
   */
  function cancelRequest() {
    source.cancel('cancel');
    source = CancelToken.source();
  }


  /**
   * 채팅 목록
   * @param {URLSearchParams} params 요청 파라미터
   */
  async function getChatList(params) {
    let response = await axios.post(`/api/chat/getChatList`, util.convertToURLParams(params), {cancelToken: source.token});
    return response.data;
  }


  return {
    cancelRequest: cancelRequest,
    getChatList: getChatList,
  }
}()


export default chat;